import { A11y, Autoplay, default as Swiper, default as SwiperCore } from 'swiper';
import 'swiper/css/bundle';
import { Component } from '../../../libs/gin-tonic/helpers/compiler';

SwiperCore.use([A11y, Autoplay]);


@Component({ className: 'js-logo-list' })
export class LogoListsComponent {
	constructor(private element: HTMLElement) {
		new Swiper(this.element, {
			slidesPerView: 'auto',
			loop: true,
			speed: 1000,
			spaceBetween: 100,
			direction: 'horizontal',
			autoplay: {
				delay: 2000,
				disableOnInteraction: false
			}
		});
	}
}
